import { CalendarDays, MapPin, ArrowRight } from "lucide-react";

export const Cohorts = ({ cohorts, loading, selectedCohort, onSelect, onEnquire }) => (
  <section id="cohorts" data-testid="cohorts-section" className="py-24 px-6 md:px-12 max-w-6xl mx-auto">
    <div className="max-w-xl mb-12">
      <span className="font-monolbl text-xs uppercase tracking-[0.2em] text-forest font-semibold">
        Upcoming Intakes
      </span>
      <h2 className="font-display text-3xl md:text-5xl tracking-tight text-ink mt-2">
        February 2027 — the first LymphoMetabolic intake.
      </h2>
      <p className="text-moss text-base mt-4">
        Small cohorts for close supervision. Reserve your place online or send an enquiry and
        Elisabete will confirm exact dates with you.
      </p>
    </div>

    {loading ? (
      <div className="h-40 rounded-2xl border border-cream bg-sand animate-pulse" data-testid="cohorts-loading" />
    ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl">
        {cohorts.map((c) => (
          <div
            key={c.id}
            data-testid={`cohort-card-${c.id}`}
            className={`bg-linen rounded-2xl border p-8 transition-colors ${
              selectedCohort === c.id ? "border-forest shadow-md" : "border-cream hover:border-forest/50"
            }`}
          >
            <span className="font-monolbl text-xs font-semibold px-3 py-1 rounded-full bg-forest/10 text-forest uppercase tracking-wider">
              {c.dates_display}
            </span>
            <h3 className="font-display text-2xl text-ink mt-4 mb-2">{c.label}</h3>
            <p className="text-sm text-moss mb-4">{c.detail}</p>
            <div className="flex flex-col gap-2 text-sm text-sage mb-6">
              <span className="flex items-center gap-2">
                <CalendarDays className="w-4 h-4 text-forest" /> 3-day course, CPD qualification
              </span>
              <span className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-forest" /> {c.venue}
              </span>
            </div>
            <div className="flex flex-wrap gap-3">
              <a
                data-testid={`cohort-reserve-${c.id}`}
                href="#pricing"
                onClick={() => onSelect(c.id)}
                className="px-5 py-2.5 rounded-full bg-forest text-linen text-xs font-semibold uppercase tracking-wider hover:bg-ink transition-colors inline-flex items-center gap-2"
              >
                Reserve this intake <ArrowRight className="w-3.5 h-3.5" />
              </a>
              <a
                data-testid={`cohort-enquire-${c.id}`}
                href="#enquire"
                onClick={() => onEnquire(c.id)}
                className="px-5 py-2.5 rounded-full border border-forest/30 text-forest text-xs font-semibold uppercase tracking-wider hover:border-forest transition-colors"
              >
                Ask about dates
              </a>
            </div>
          </div>
        ))}
      </div>
    )}
  </section>
);
